import type { SuDashboard } from '../../api';

/**
 * 수퍼유저 화면 공통 표기(§14.19) — 화면마다 따로 번역하지 않게 한 곳에 둔다(`admin/labels.ts` 와 같은 원칙).
 */

/** 조직 상태(orgs.status). */
export const ORG_STATUS_LABEL: Readonly<Record<string, string>> = {
  active: '사용 중',
  disabled: '정지',
  deleted: '삭제됨', // 삭제 표시(§14.19.10) — "삭제된 조직" 목록에서만 보인다
};

/** 대시보드 숫자 칸 — **데이터로** 정의한다(칸을 늘릴 때 JSX 를 복사하지 않게). */
export const SU_STAT_TILES: ReadonlyArray<{ label: string; value: (t: SuDashboard['totals']) => string }> = [
  { label: '조직(사용 중/전체)', value: (t) => `${t.activeOrgs} / ${t.orgs}` },
  { label: '사용자', value: (t) => String(t.users) },
  { label: '기기(온라인/전체)', value: (t) => `${t.onlineDevices} / ${t.devices}` },
  { label: '접속 중 뷰어', value: (t) => String(t.onlineViewers) },
  { label: '진행 중 세션', value: (t) => String(t.activeSessions) },
  { label: '세션 24시간', value: (t) => String(t.sessions24h) },
  { label: '세션 7일', value: (t) => String(t.sessions7d) },
  { label: '코드 접속 7일', value: (t) => String(t.anonSessions7d) },
];

/** 바이트 → 사람이 읽는 크기(GiB/MiB). */
export function fmtBytes(n: number | null | undefined): string {
  if (n === null || n === undefined) return '-';
  const gib = n / 1024 ** 3;
  return gib >= 1 ? `${gib.toFixed(1)} GiB` : `${(n / 1024 ** 2).toFixed(0)} MiB`;
}

/** 초 → "3일 4시간 5분". */
export function fmtUptime(sec: number): string {
  const d = Math.floor(sec / 86400);
  const h = Math.floor((sec % 86400) / 3600);
  const m = Math.floor((sec % 3600) / 60);
  return [d ? `${d}일` : '', h ? `${h}시간` : '', `${m}분`].filter(Boolean).join(' ');
}
